import * as MdIcons from 'react-icons/md';
import { MobergFontFamily } from '../MobergFont/MobergFont';
import { useWorkspacesProvider } from '../../Providers/WorkspacesProvider';

const WorkspaceDisplay = () => {
    const { selectedWorkspace } = useWorkspacesProvider();

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdIcons.MdComputer size={24} style={{ color: 'var(--text-secondary-color)' }} />
            <span style={{ fontFamily: MobergFontFamily.HEADER, fontWeight: 500, fontSize: 16, color: 'var(--text-secondary-color)', marginLeft: 4, marginRight: 4 }}>
                Workspace
            </span>
            <span
                style={{
                    fontFamily: MobergFontFamily.REGULAR,
                    fontSize: 16,
                    color: 'var(--text-color)',
                    marginLeft: 4,
                    marginRight: 4,
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {selectedWorkspace?.toUpperCase() || 'DEMO'}
            </span>
        </div>
    );
};

export default WorkspaceDisplay; 